const CartActionTypes = {
  ADD_PRODUCT: "cart/addProduct",
  REMOVE_PRODUCT: "cart/removeProduct",
  INCREASE_PRODUCT_QUANTITY: "cart/increaseProductQuantity",
  DECREASE_PRODUCT_QUANTITY: "cart/decreasePorductQuantity",
};

export default CartActionTypes;
